import q1 from '@assets/img/q1.png'
import q3 from '@assets/img/q3.png'
import q4 from '@assets/img/q4.png'
import q6 from '@assets/img/q6.png'
import q8 from '@assets/img/q8.png'
import q11 from '@assets/img/q11.png'
import q13 from '@assets/img/q13.png'

let imagetAlternativeA =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><circle cx="8" cy="8" r="6" stroke="#FF48B0" stroke-width="4"/></svg>'
let imagetAlternativeB =
    '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none"><circle cx="5" cy="5" r="2.5" stroke="#FF48B0" stroke-width="5"/></svg>'
let imagetAlternativeC =
    '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="14" cy="14" r="6" stroke="#FF48B0" stroke-width="4"/><circle cx="14" cy="14" r="13" stroke="#FF48B0" stroke-width="2"/></svg>'
let imagetAlternativeD =
    '<svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="none"><circle cx="19" cy="19" r="6" stroke="#FF48B0" stroke-width="4"/><circle cx="19" cy="19" r="13" stroke="#FF48B0" stroke-width="2"/><circle cx="19" cy="19" r="18" stroke="#FF48B0" stroke-width="2"/></svg>'

export const questions = [
    {
        id: 0,
        question: 'Hur många kvadrater<br/>hittar du?',
        questionImage: q1,
        options: [
            { text: 'a. 4', isCorrect: false },
            { text: 'b. 6', isCorrect: false },
            { text: 'c. 8', isCorrect: true },
            { text: 'd. 10', isCorrect: false }
        ]
    },
    {
        id: 1,
        question: 'Hur många kulor ligger det i lådan som har nummer 8 när Albert är klar?',
        questionText:
            'Albert har tio tomma lådor som är numrerade med heltalen 1-10. Först lägger Albert en kula i varje låda vars nummer är jämnt delbart med 2, och så vidare ända upp till 10. Albert lägger alltså k stycken kulor i varje låda vars nummer är jämnt delbart med k för varje heltal k från 1 till 10.',
        options: [
            { text: 'a. 15', isCorrect: true },
            { text: 'b. 9', isCorrect: false },
            { text: 'c. 7', isCorrect: false },
            { text: 'd. 10', isCorrect: false }
        ]
    },
    {
        id: 2,
        question: 'Välj ett logiskt svar',
        questionImage: q3,
        isImageAlternative: true,
        options: [
            { text: 'a. 15', imageAlternative: imagetAlternativeA, isCorrect: true },
            { text: 'b. 9', imageAlternative: imagetAlternativeB, isCorrect: false },
            { text: 'c. 7', imageAlternative: imagetAlternativeC, isCorrect: false },
            { text: 'd. 10', imageAlternative: imagetAlternativeD, isCorrect: false }
        ]
    },
    {
        id: 3,
        question: 'En rektangel och en cirkel har samma omkrets. Vilken har större area?',
        questionImage: q4,
        options: [
            { text: 'a.', isCorrect: false },
            { text: 'b.', isCorrect: true },
            { text: 'c.', isCorrect: false },
            { text: 'd.', isCorrect: false }
        ]
    },
    {
        id: 4,
        question:
            'Om fem katter kan fånga fem möss på fem minuter, hur många katter behövs för att fånga 100 möss på 100 minuter?',
        options: [
            { text: 'a. 5', isCorrect: true },
            { text: 'b. 20', isCorrect: false },
            { text: 'c. 100', isCorrect: false },
            { text: 'd. 1', isCorrect: false }
        ]
    },
    {
        id: 5,
        question: 'Räkna ut antalet trianglar',
        questionImage: q6,
        options: [
            { text: 'a. 9', isCorrect: false },
            { text: 'b. 12', isCorrect: false },
            { text: 'c. 14', isCorrect: false },
            { text: 'd. 13', isCorrect: true }
        ]
    },
    {
        id: 6,
        question: 'Hur lång tid tar det innan Julia och Anna möts?',
        questionText:
            'Avståndet mellan Julia och Annas hem är 12 kilometer. De startar samtidigt från sina respektive hem för att mötas längs vägen. Julia springer med konstant hastighet och det tar henne 12 minuter att springa två kilometer. Anna går med konstant hastighet och det tar henne 24 minuter att gå två kilometer.',
        options: [
            { text: 'a. 42 min', isCorrect: true },
            { text: 'b. 48 min', isCorrect: false },
            { text: 'c. 36 min', isCorrect: false },
            { text: 'd. 72 min', isCorrect: false }
        ]
    },
    {
        id: 7,
        question: 'Vilket tal ska ersätta frågetecknet?',
        questionImage: q8,
        options: [
            { text: 'a. 22', isCorrect: false },
            { text: 'b. 16', isCorrect: false },
            { text: 'c. 18', isCorrect: true },
            { text: 'd. 20', isCorrect: false }
        ]
    },
    {
        id: 8,
        question: 'Hur många kulor ligger i lådan som har nummer 8 när My är klar?',
        questionText:
            'My har 10 tomma lådor som är numrerade från 1-10. Först lägger My en kula i varje låda vars nummer är jämnt delbart med ett. Sedan lägger hon två kulor i varje låda som är jämt delbart med två, och så vidare hela vägen upp till 10. Hur många kulor ligger i lådan som har nummer 8 när My är klar?',
        options: [
            { text: 'a. 7', isCorrect: false },
            { text: 'b. 9', isCorrect: false },
            { text: 'c. 11', isCorrect: false },
            { text: 'd. 15', isCorrect: true }
        ]
    },
    {
        id: 9,
        question: 'Vad behöver du för att svara på frågan?',
        questionText:
            'Eva har fyra askar: en röd, en blå, en svart och en grå. En av askarna innehåller pärlor, en knappar, en paljetter och en limstift. Ingen ask är tom. I vilken ask har Eva limstift? (1) I den blå eller den grå asken finns det pärlor. Limstift finns inte i den röda asken.(2) I den svarta asken finns det paljetter. Limstift finns i den blå eller den grå asken.',
        options: [
            { text: 'a. i (1) men ej i (2)', isCorrect: false },
            { text: 'b.  i (2) men ej i (1)', isCorrect: false },
            { text: 'c. i (1) tillsammans med (2)', isCorrect: false },
            { text: 'd. Ej genom de båda', isCorrect: true }
        ]
    },
    {
        id: 10,
        question: 'Vilket tal ska ersätta frågetecknet?',
        questionImage: q11,
        options: [
            { text: 'a. 5', isCorrect: false },
            { text: 'b. 8', isCorrect: true },
            { text: 'c. 3', isCorrect: false },
            { text: 'd. 7', isCorrect: false }
        ]
    },
    {
        id: 11,
        question: 'Textfråga kommer här sen',
        questionText:
            'Lorem ipsum dolor sit amet consectetur. Fermentum fringilla ligula molestie nunc amet adipiscing urna nullam. Diam praesent sed vulputate commodo tincidunt pellentesque. Morbi quis vitae dictum maecenas non vestibulum. Duis varius nulla nibh at proin.',
        options: [
            { text: 'a.', isCorrect: false },
            { text: 'b.', isCorrect: true },
            { text: 'c.', isCorrect: false },
            { text: 'd.', isCorrect: false }
        ]
    },
    {
        id: 12,
        question: 'Vilket tal ska ersätta frågetecknet?',
        questionImage: q13,
        options: [
            { text: 'a. 3', isCorrect: true },
            { text: 'b. 4', isCorrect: false },
            { text: 'c. 5', isCorrect: false },
            { text: 'd. 6', isCorrect: false }
        ]
    },
    {
        id: 13,
        question: 'Textfråga kommer här sen',
        questionText:
            'Lorem ipsum dolor sit amet consectetur. Fermentum fringilla ligula molestie nunc amet adipiscing urna nullam. Diam praesent sed vulputate commodo tincidunt pellentesque. Morbi quis vitae dictum maecenas non vestibulum. Duis varius nulla nibh at proin.',
        options: [
            { text: 'a.', isCorrect: false },
            { text: 'b.', isCorrect: true },
            { text: 'c.', isCorrect: false },
            { text: 'd.', isCorrect: false }
        ]
    },
    {
        id: 14,
        question: 'Textfråga kommer här sen',
        questionText:
            'Lorem ipsum dolor sit amet consectetur. Fermentum fringilla ligula molestie nunc amet adipiscing urna nullam. Diam praesent sed vulputate commodo tincidunt pellentesque. Morbi quis vitae dictum maecenas non vestibulum. Duis varius nulla nibh at proin.',
        options: [
            { text: 'a.', isCorrect: false },
            { text: 'b.', isCorrect: true },
            { text: 'c.', isCorrect: false },
            { text: 'd.', isCorrect: false }
        ]
    }
]
